export const AGREGAR_QUERY = "AGREGAR_QUERY"